import React from 'react';
import PropTypes from 'prop-types';

import { Drawer, Grid } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const AdvisorGrowBusinessDrawer = ({ open, onClose, accordion, setAccordion }) => {
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Grid container className="drawer-max-width">
        <Grid container className="drawer-hdr">
          <Grid item xs={11}>
            <span className="subhead">Grow Your Business</span>
          </Grid>
          <Grid item xs={1} className="pull-right">
            <a role="link" tabIndex={0} onClick={onClose} onKeyDown={onClose}>
              <img src="/plus_frontend/assets/svg/x-close.svg" alt="close" />
            </a>
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 10, lineHeight: '1.5em' }}>
          <Grid item xs={12}>
            <Accordion
              expanded={accordion === 'promote'}
              onChange={() => setAccordion(accordion === 'promote' ? false : 'promote')}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                Promote Your Business
              </AccordionSummary>
              <AccordionDetails>
                <ol>
                  <li>One</li>

                  <li>Two</li>

                  <li>Three</li>
                </ol>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={accordion === 'enhance'}
              onChange={() => setAccordion(accordion === 'enhance' ? false : 'enhance')}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                Enhance Your Business
              </AccordionSummary>
              <AccordionDetails>
                <ol>
                  <li>One</li>

                  <li>Two</li>

                  <li>Three</li>
                </ol>
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>
      </Grid>
    </Drawer>
  );
};

AdvisorGrowBusinessDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  accordion: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  setAccordion: PropTypes.func.isRequired,
};

export default AdvisorGrowBusinessDrawer;
